import React from 'react';

const LabelR = (props) => {
  const { children, htmlFor = '', requiredFields = [htmlFor], isEditable = true, name } = props;
  const cn = requiredFields.indexOf(htmlFor) === -1 || !isEditable ? '' : 'labelr';

  return (
    <label htmlFor={htmlFor} className={cn} id={`${name}-label`}>
      {children}
    </label>
  );
};

export default LabelR;